import { CreateElement } from 'vue'
import { RouteConfig } from 'vue-router'
import { CreateRouterOptions } from '@/typings/common'
import { LK_MUN_MEH_FORM_REVIEW_ROUTES as ROUTES } from './utils'

// import { lkStoreModule } from '@/store/modules/lk'
// import { lkMunMehPermissions as Permissions } from '@/helpers/enums/permission-models'
// import { HOME_LK_ROUTES } from '@/views/HomeLK/utils'


type Options = Required<CreateRouterOptions>
type PromiseVue = Promise<typeof import('*.vue')>

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const createRoutes = (options: Options): RouteConfig[] => [
  {
    path: 'review/:munMehId/form/:formId/:viewType?',
    name: ROUTES.LAYOUT,
    meta: { authorized: true },
    async beforeEnter(to, from, next) {
      // const storeModule = lkStoreModule.context(options.store)
      // if (!storeModule.getters.$access(Permissions.expert)) {
      //   const location = {
      //     name: HOME_LK_ROUTES.LAYOUT,
      //   }
      //
      //   next(location)
      //   return
      // }

      const { registerModule } = await import(
        /* webpackChunkName: "mun-meh-lk-form-review.store" */
        './store'
      )
      registerModule(options)
      next()
    },
    component: {
      name: 'ViewLKMunMehFormLayout',
      render: (h: CreateElement) => h('router-view'),
    },
    children: [
      {
        path: 'indicators/:levels(.*)',
        name: ROUTES.ANY_LEVEL,
        props: true,
        component: (): PromiseVue => import(
          /* webpackChunkName: "mun-meh-lk.form.review.view.level" */
          './LKMunMehExpertView.vue'
        ),
      },
      {
        path: '/',
        name: ROUTES.FORM,
        props: true,
        component: (): PromiseVue => import(
          /* webpackChunkName: "mun-meh-lk.form.review.view" */
          './LKMunMehExpertView.vue'
        ),
      },
    ],
  },
]

const createSubModule = (options: Options) => {
  const routes = createRoutes(options)
  return routes
}

export default createSubModule
